import { Vue, Component } from "vue-property-decorator";
import axios from "axios";
// Components
import { AddWarehouseToCompany } from "@/components/index";
// Entities
import { Warehouse, WarehouseToCompany, Company } from "@/entities/index";

@Component({
  components: {
    AddWarehouseToCompany,
  },
})
export default class warehouseToCompany extends Vue {
  warehouseToCompany: WarehouseToCompany[] = [];
  warehouses: Warehouse[] = [];
  companies: Company[] = [];

  selectedWarehouse = "";
  selectedCompany = "";

  headersWarehouseToCompanyTable = [
    {
      text: "Entrepôt",
      align: "start",
      value: "warehouse.name",
      class: "indigo--text text--darken-4",
    },
    {
      text: "Client",
      value: "company.name",
      class: "indigo--text text--darken-4",
    },
  ];

  // ========== CRUD ========== //

  async allWarehousesToCompanies(): Promise<void> {
    this.warehouseToCompany = (await axios.get(`/api/warehouses-to-companies`))
      .data as WarehouseToCompany[];
  }

  async allCompanies(): Promise<void> {
    this.companies = (await axios.get(`/api/companies`)).data as Company[];
  }

  async allWarehouses(): Promise<void> {
    this.warehouses = (await axios.get(`/api/warehouses`)).data as Warehouse[];
  }

  mounted(): void {
    this.allWarehousesToCompanies();
    this.allCompanies();
    this.allWarehouses();
  }

  // ========== OTHER METHODS ========== //

  colorRow(item: WarehouseToCompany): any {
    const position = this.warehouseToCompany.indexOf(item, 0);
    if (position % 2 == 0) {
      return "light-green lighten-5";
    }
  }
}
